import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NewsletterModalComponent } from 'src/app/modals/newsletter-modal/newsletter-modal.component';
import { environment } from 'src/environments/environment';
import { User, UserCommunicationPreferences } from 'src/app/interfaces/user';
import { RegistrationFlowStep } from 'src/app/constants/registration-flow.constants';
import { UserService } from '../user/user.service';
import { RegistrationFlowService } from '../registration-flow/registration-flow.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OptInPopupService {
  private readonly popupName = 'Step4OptInPopup';
  private readonly popupUrl = `${environment.apiUrl}/api/popup`;

  private popupSeenSuccessSubject = new Subject<void>();
  public popupSeenSuccess$ = this.popupSeenSuccessSubject.asObservable();

  constructor(
    private http: HttpClient,
    private modalService: NgbModal,
    public userService: UserService,
    private registrationFlowService: RegistrationFlowService
  ) { }

  public checkAndShowNewsletterPopup(userPets: string, user: User): void {
    this.http
      .get<{ isSeen: boolean; name: string }>(`${this.popupUrl}/${this.popupName}`)
      .subscribe({
        next: (response) => {
          const hasCommunicationPrefs =
            user.communicationPreferences.email ||
            user.communicationPreferences.telephone ||
            user.communicationPreferences.sms ||
            user.communicationPreferences.thirdPartyCommunicationEmail ||
            user.communicationPreferences.thirdPartyCommunicationSms;

          if (
            !response.isSeen &&
            this.registrationFlowService.isStepCompleted(RegistrationFlowStep.WelcomeGift) &&
            !hasCommunicationPrefs
          ) {
            this.showNewsletterModal(userPets);
          }
        },
        error: (err) => {
          console.error('Error checking popup status', err);
        }
    });
  }

  private showNewsletterModal(userPets: string): void {
    const modalOptions: NgbModalOptions = {
      centered: true,
      size: 'md',
      windowClass: 'newsletter-modal-window',
    };

    const modalRef = this.modalService.open(NewsletterModalComponent, modalOptions);
    modalRef.componentInstance.petName = userPets;

    modalRef.result
      .then(() => {
        const userChanges: Partial<User> = {
          communicationPreferences: {
            email: true,
            sms: true,
            telephone: true,
            thirdPartyCommunicationEmail: true,
            thirdPartyCommunicationSms: true
          } as UserCommunicationPreferences
        };

        this.userService.patchMe(userChanges).subscribe({
          next: () => {
            this.popupSeenSuccessSubject.next();
          },
          error: (err) => {
            console.error(err.message);
          }
        });

        this.markPopupAsSeen();
      })
      .catch(() => {
        this.markPopupAsSeen();
      });
  }

  private markPopupAsSeen(): void {
    const payload = { name: this.popupName };

    this.http.put(this.popupUrl, payload).subscribe({
      next: () => {},
      error: (err) => console.error('Failed to update popup status', err)
    });
  }
}
